export default __webpack_public_path__ + "static/JGSummit-cc18ce6e0db906ca69279670b317b4a3.jpg";